import { FaxesPage } from '@/pages/Faxes';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

// Unlike Practitioners there is no `search` term param — `Communication` has no
// searchable field for the payload attachment title, so a search box can't be
// wired server-side.
const FaxSearchSchema = z.object({
  direction: z.enum(['inbound', 'outbound']).default('inbound'),
  organizationId: z.string().min(1).optional(),
  // Persisted across tab switches; the page only applies it on the inbound tab.
  readStatus: z.enum(['read', 'unread']).optional(),
  // Defaults to the unassigned work queue; persisted across tab switches like readStatus.
  assignment: z.enum(['all', 'unassigned']).default('unassigned'),
  pageSize: z.number().int().min(1).max(1000).default(20),
});

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { direction, organizationId, readStatus, assignment, pageSize } = Route.useSearch();
  // oxlint-disable-next-line no-use-before-define
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <FaxesPage
      direction={direction}
      setDirection={(direction) => {
        void navigate({ search: (prev) => ({ ...prev, direction }) });
      }}
      organizationId={organizationId}
      setOrganizationId={(organizationId) => {
        void navigate({ search: (prev) => ({ ...prev, organizationId }) });
      }}
      readStatus={readStatus}
      setReadStatus={(readStatus) => {
        void navigate({ search: (prev) => ({ ...prev, readStatus }) });
      }}
      assignment={assignment}
      setAssignment={(assignment) => {
        void navigate({ search: (prev) => ({ ...prev, assignment }) });
      }}
      pageSize={pageSize}
      setPageSize={(pageSize) => {
        void navigate({ search: (prev) => ({ ...prev, pageSize }) });
      }}
    />
  );
};

export const Route = createFileRoute('/_auth/faxes/')({
  component: RouteComponent,
  loader: () => ({ crumb: 'Faxes' }),
  validateSearch: FaxSearchSchema,
});
